import gray from './gray';

const colors = {
  pixelmoxie: 'hsla(340, 88%, 54%, 1)',
  blue: 'hsla(236, 88%, 48%, 1)',
  yellow: 'hsla(43, 88%, 56%, 1)',
  purple: 'hsla(255, 61%, 39%, 1)',
  navAccent: '',
  accent: {
    yellow: 'hsla(37, 100%, 61%, 1)',
    green: 'hsla(160, 96%, 48%, 1)',
    flush: 'hsla(340, 75%, 43%, 1)',
    highlight: 'hsla(43, 88%, 86%, 1)',
  },
  ui: {
    whisper: gray(94, 'cool'),
    bright: '#fff',
    flush: 'hsla(340, 75%, 43%, 1)',
    darkPurple: 'hsla(251, 28%, 19%, 1)',
    darkBlue: 'hsla(236, 70%, 33%, 1)',
    darkBlueChill: 'hsla(192, 84%, 19%, 1)',
  },
  gray: {
    dark: gray(8, 'cool'),
    copy: gray(13, 'cool'),
    gunpowder: gray(30, 'cool'),
    calm: gray(46, 'cool'),
  },
};

export default colors;



// WEBPACK FOOTER //
// ./src/utils/colors.js